// src/pages/Admin/AdminMaintenance/AdminMaintenance.jsx
import React, { useState, useEffect, useCallback } from 'react';
import AdminSidebar from '../../../components/AdminSidebar/AdminSidebar';
import { useAuth } from '../../../context/AuthContext';
import './AdminMaintenance.css';

const AdminMaintenance = () => {
  const { validateToken, authToken } = useAuth();
  const [isUnderMaintenance, setIsUnderMaintenance] = useState(false);
  const [isFivemMaintenance, setIsFivemMaintenance] = useState(false);
  const [loading, setLoading] = useState(true);
  const [fivemLoading, setFivemLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Función para obtener el estado del modo mantenimiento general
  const fetchMaintenanceStatus = useCallback(async () => {
    console.log('🔍 Obteniendo estado de mantenimiento desde:', 'https://riasbaixaspd.es/api/maintenance');
    try {
      const response = await fetch('https://riasbaixaspd.es/api/maintenance');
      console.log('📥 Estado fetch response:', response.status);
      if (response.ok) {
        const data = await response.json();
        console.log('✅ Estado obtenido:', data);
        setIsUnderMaintenance(data.isUnderMaintenance || false);
      } else if (response.status === 401) {
        setError('Sesión expirada. Redirigiendo al login...');
        localStorage.clear();
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
      } else {
        setError('Error al obtener el estado de mantenimiento');
      }
    } catch (err) {
      console.error('❌ Error fetching maintenance status:', err);
      setError('Error de conexión al servidor: ' + err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  // Función para obtener el estado del mantenimiento del servidor FiveM
  const fetchFivemMaintenanceStatus = useCallback(async () => {
    console.log('🔍 Obteniendo estado de mantenimiento FiveM desde:', 'https://riasbaixaspd.es/api/fivem-maintenance');
    
    // Validar token antes de hacer la petición
    const isTokenValid = await validateToken();
    if (!isTokenValid) {
      setError('Sesión expirada. Redirigiendo al login...');
      return;
    }
    
    try {
      const token = authToken || localStorage.getItem('authToken');
      if (!token) {
        setError('No se encontró token de autenticación');
        return;
      }
      
      const response = await fetch('https://riasbaixaspd.es/api/fivem-maintenance', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      console.log('📥 Estado FiveM fetch response:', response.status);
      if (response.ok) {
        const data = await response.json();
        console.log('✅ Estado FiveM obtenido:', data);
        setIsFivemMaintenance(data.fivem_maintenance || false);
      } else if (response.status === 401) {
        setError('Sesión expirada. Redirigiendo al login...');
        localStorage.clear();
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
      } else {
        setError('Error al obtener el estado de mantenimiento del servidor');
      }
    } catch (err) {
      console.error('❌ Error fetching FiveM maintenance status:', err);
      setError('Error de conexión al servidor: ' + err.message);
    }
  }, [validateToken, authToken]);

  // Función para cambiar el modo mantenimiento
  const toggleMaintenanceMode = async () => {
    console.log('🔄 toggleMaintenanceMode ejecutado. Estado actual:', isUnderMaintenance);
    setLoading(true);
    setError('');
    setSuccess('');
    
    try {
      const newMode = !isUnderMaintenance;
      const token = localStorage.getItem('token');
      
      console.log('📡 Enviando petición a:', 'https://riasbaixaspd.es/api/maintenance-test');
      console.log('🔑 Token presente:', token ? 'Sí' : 'No');
      console.log('📝 Cambiando modo mantenimiento a:', newMode ? 'ACTIVADO' : 'DESACTIVADO');
      
      const response = await fetch('https://riasbaixaspd.es/api/maintenance-test', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          enabled: newMode
        }),
      });

      console.log('📥 Respuesta status:', response.status);
      
      if (response.ok) {
        const data = await response.json();
        console.log('✅ Respuesta exitosa:', data);
        setIsUnderMaintenance(data.isUnderMaintenance);
        setSuccess(`Modo mantenimiento ${data.isUnderMaintenance ? 'activado' : 'desactivado'} correctamente`);
      } else {
        const errorText = await response.text();
        console.error('❌ Error al cambiar modo mantenimiento. Status:', response.status, 'Response:', errorText);
        setError(`Error al cambiar modo mantenimiento: ${response.status} - ${errorText}`);
      }
    } catch (err) {
      console.error('❌ Error toggling maintenance mode:', err);
      setError('Error de conexión: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  // Función para cambiar el mantenimiento del servidor FiveM
  const toggleFivemMaintenanceMode = async () => {
    console.log('🔄 toggleFivemMaintenanceMode ejecutado. Estado actual:', isFivemMaintenance);
    setFivemLoading(true);
    setError('');
    setSuccess('');
    
    // Validar token antes de hacer la petición
    const isTokenValid = await validateToken();
    if (!isTokenValid) {
      setError('Sesión expirada. Redirigiendo al login...');
      setFivemLoading(false);
      return;
    }
    
    try {
      const newMode = !isFivemMaintenance;
      const token = authToken || localStorage.getItem('authToken');
      
      if (!token) {
        setError('No se encontró token de autenticación');
        setFivemLoading(false);
        return;
      }
      
      console.log('📡 Enviando petición FiveM a:', 'https://riasbaixaspd.es/api/fivem-maintenance');
      console.log('🔑 Token presente:', token ? 'Sí' : 'No');
      console.log('📝 Cambiando modo FiveM a:', newMode ? 'ACTIVADO' : 'DESACTIVADO');
      
      const response = await fetch('https://riasbaixaspd.es/api/fivem-maintenance', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          enabled: newMode
        }),
      });

      console.log('📥 Respuesta FiveM status:', response.status);
      
      if (response.ok) {
        const data = await response.json();
        console.log('✅ Respuesta FiveM exitosa:', data);
        setIsFivemMaintenance(data.fivem_maintenance);
        setSuccess(`Mantenimiento del servidor ${data.fivem_maintenance ? 'activado' : 'desactivado'} correctamente`);
      } else {
        const errorText = await response.text();
        console.error('❌ Error al cambiar mantenimiento FiveM. Status:', response.status, 'Response:', errorText);
        setError(`Error al cambiar mantenimiento del servidor: ${response.status} - ${errorText}`);
      }
    } catch (err) {
      console.error('❌ Error toggling FiveM maintenance mode:', err);
      setError('Error de conexión: ' + err.message);
    } finally {
      setFivemLoading(false);
    }
  };

  // Cargar estado inicial
  useEffect(() => {
    fetchMaintenanceStatus();
    fetchFivemMaintenanceStatus();
  }, [fetchMaintenanceStatus, fetchFivemMaintenanceStatus]);

  return (
    <div className="admin-maintenance-container">
      <AdminSidebar />
      <div className="admin-content">
        <h2 className="admin-page-title">Modo Mantenimiento</h2>
        <p className="admin-subtitle">Gestiona el estado de mantenimiento del sitio web</p>

        {/* Mostrar errores */}
        {error && (
          <div className="alert alert-error">
            <i className="icon-error"></i>
            {error}
          </div>
        )}

        {/* Mostrar éxito */}
        {success && (
          <div className="alert alert-success">
            <i className="icon-success"></i>
            {success}
          </div>
        )}

        {/* Panel principal de mantenimiento */}
        <div className="maintenance-panel web-maintenance">
          <div className="panel-header">
            <h3 className="panel-title">🌐 Mantenimiento General de la Web</h3>
            <p className="panel-subtitle">Controla el acceso completo al sitio web para todos los usuarios</p>
          </div>

          <div className="maintenance-status">
            <div className="status-indicator">
              <div className={`status-light ${isUnderMaintenance ? 'active' : 'inactive'}`}></div>
              <div className="status-info">
                <h3 className="status-title">Estado Actual</h3>
                <p className={`status-text ${isUnderMaintenance ? 'active' : 'inactive'}`}>
                  {isUnderMaintenance ? 'MANTENIMIENTO ACTIVADO' : 'SITIO OPERATIVO'}
                </p>
              </div>
            </div>
          </div>

          <div className="maintenance-controls">
            <button
              onClick={toggleMaintenanceMode}
              disabled={loading}
              className={`maintenance-toggle-btn ${isUnderMaintenance ? 'deactivate' : 'activate'} ${loading ? 'loading' : ''}`}
            >
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Procesando...
                </>
              ) : (
                <>
                  {isUnderMaintenance ? 'Desactivar Mantenimiento' : 'Activar Mantenimiento'}
                </>
              )}
            </button>
          </div>

          <div className="maintenance-info">
            <div className="info-card web-info">
              <h4>🌐 Información - Mantenimiento General</h4>
              <ul>
                <li><strong>Activar:</strong> Los usuarios no podrán acceder al sitio y verán la página de mantenimiento.</li>
                <li><strong>Desactivar:</strong> El sitio funcionará normalmente para todos los usuarios.</li>
                <li><strong>Administradores:</strong> Siempre pueden acceder independientemente del estado.</li>
                <li><strong>Impacto total:</strong> Bloquea completamente el acceso a la aplicación web.</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Panel de mantenimiento del servidor FiveM */}
        <div className="maintenance-panel fivem-maintenance">
          <div className="panel-header">
            <h3 className="panel-title">🎮 Mantenimiento del Servidor FiveM</h3>
            <p className="panel-subtitle">Controla el estado del servidor de juego sin afectar la web</p>
          </div>

          <div className="maintenance-status">
            <div className="status-indicator">
              <div className={`status-light ${isFivemMaintenance ? 'active' : 'inactive'}`}></div>
              <div className="status-info">
                <h3 className="status-title">Estado del Servidor</h3>
                <p className={`status-text ${isFivemMaintenance ? 'active' : 'inactive'}`}>
                  {isFivemMaintenance ? 'SERVIDOR EN MANTENIMIENTO' : 'SERVIDOR OPERATIVO'}
                </p>
              </div>
            </div>
          </div>

          <div className="maintenance-controls">
            <button
              onClick={toggleFivemMaintenanceMode}
              disabled={fivemLoading}
              className={`maintenance-toggle-btn ${isFivemMaintenance ? 'deactivate' : 'activate'} ${fivemLoading ? 'loading' : ''}`}
            >
              {fivemLoading ? (
                <>
                  <span className="spinner"></span>
                  Procesando...
                </>
              ) : (
                <>
                  {isFivemMaintenance ? 'Reactivar Servidor' : 'Poner en Mantenimiento'}
                </>
              )}
            </button>
          </div>

          <div className="maintenance-info">
            <div className="info-card fivem-info">
              <h4>🎮 Información - Servidor FiveM</h4>
              <ul>
                <li><strong>Activar:</strong> El contador de jugadores mostrará "Servidor en Mantenimiento".</li>
                <li><strong>Web operativa:</strong> Los usuarios pueden navegar por la web normalmente.</li>
                <li><strong>Solo servidor:</strong> Afecta únicamente al estado mostrado del servidor de juego.</li>
                <li><strong>Script Qbox:</strong> Puede seguir actualizando independientemente.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminMaintenance;